<template>
    <span data-balloon="Delete Product" data-balloon-pos="up">
        <button class="delete simple" @click="open"><i class="fa fa-trash"></i></button>

        <div class="remodal" :data-remodal-id="modalID">
            <p>Are you sure you want to delete <strong>{{name}}</strong>?</p>
            <button data-remodal-action="cancel" class="alternate simple">Cancel</button>
            <button data-remodal-action="confirm" class="simple" @click="confirm">OK</button>
        </div>

    </span>

</template>

<script>
    import Modal from 'vue/common/_modal';
    import {mapActions} from 'vuex'

    export default {
        computed: {
            modalID() {
                return `${this.item.productId}-delete`
            }
        },
        methods: {
            confirm() {
                this.deleteProduct({
                    submittalID: this.submittalID,
                    objectID: this.result.productId
                })
                .then(()=>{
                    this.$emit('refresh');
                })
                .catch(response => {
                    //console.log(response);
                })
            },

            ...mapActions('mechanical', [
                'deleteProduct'
            ])
        },
        extends: Modal,
        props: ['submittalID']
    }
</script>